<template>
  <div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        step: 1,
        numberOfSteps: 4,
        position: 'bottom',
        scroll: false,
      }
    },
    props: {
      tagId: {
        type: String,
        required: true,
      },
    },
    created() {
      if(this.tagId == 51 || this.tagId == 56) { this.numberOfSteps = 5 }
      if(this.$DeviceCheck.isMobile) {
        this.position = 'top';
        this.scroll = true;
      }
    },
    mounted() {
      this.$nextTick(() => {
        const tour = this.$shepherd({
          useModalOverlay: true,
          defaultStepOptions: {
            classes: 'shepherd-element shepherd-open shepherd-theme-arrows',
            scrollTo: this.scroll,
            cancelIcon: {
              enabled: true,
              label: 'Luk vejledning'
            },
            when: {
              cancel: () => {
                //console.log('tagTutorialCancel');
                localStorage.setItem('OdenseRundt-TutorialTag', 'false');
                if(this.tagId == 51 || this.tagId == 56) {
                  localStorage.setItem('OdenseRundt-TutorialFilter', 'false');
                }
                this.$HelperFunctions.trackSession('tag-tutorial', 'tag-tutorial-closed');
                //app.tagTutorialActive = false;
              }
            }
          }
        });

        tour.addStep({
          id: 'tag-menubar',
          text: '<span id="tag-tutorial-anchor" aria-label="tema side tutorial"></span><span class="material-icons icon-medium" aria-hidden="true">favorite_border</span> Tilføj favoritter ved at klikke på hjertet.<br><br>\
          <span class="material-icons icon-medium" aria-hidden="true">playlist_add</span> Du kan også føje til dine egne samlinger ved at klikke på samling.<br><br>\
          <span class="material-icons icon-medium" aria-hidden="true">camera_alt</span>/<span class="material-icons icon-small">pin_drop</span> Skift mellem billede og kort.<br><br>\
          <span class="material-icons icon-medium" aria-hidden="true">share</span> Del på sociale medier og mail.<br><br>\
          <span class="material-icons icon-medium" aria-hidden="true">report_problem</span> Tip os om fejl og mangler.\
          <br><div class="tutorial-step-counter">'+this.step+'/'+this.numberOfSteps+'</div>',
          attachTo: '.toolbar bottom',
          buttons: [
            {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('tag-tutorial', 'tag-menubar-next');
              }
            }
          ]
        });

        if(this.tagId == 51 || this.tagId == 56) {
          this.step++;
          tour.addStep({
            id: 'tag-filters',
            text: 'Gør din søgning mere præcis ved hjælp af forskellige filtre.<br><div class="tutorial-step-counter">'+this.step+'/'+this.numberOfSteps+'</div>',
            attachTo: {
              element: '.tag-filters',
              on: this.position
            },
            buttons: [
              {
                text: 'Tilbage',
                classes: 'shepherd-button-secondary',
                action: tour.back
              }, {
                text: 'Næste',
                classes: 'shepherd-button-primary blue',
                action: () => {
                  tour.next();
                  this.$HelperFunctions.trackSession('tag-tutorial', 'tag-filters-next');
                }
              }
            ]
          });
        }
        //Tag Sorting
        this.step++;
        tour.addStep({
          id: 'tag-sorting',
          text: 'Vælg om din liste skal være sorteret efter afstand eller alfabetisk.<br><div class="tutorial-step-counter">'+this.step+'/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#list-sort-selector',
            on: this.position
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('tag-tutorial', 'tag-list-sort-next');
              }
            }
          ]
        });
        //Tag custom GPS
        this.step++;
        tour.addStep({
          id: 'tag-custom-gps',
          text: 'Du kan beregne afstanden til stederne på listen via følgende muligheder.<br>\
          <ul style="list-style: disc; margin-bottom: 0px;"><li style="margin-left: 25px;">Fra en indtastet adresse eller fra din GPS</li>\
          <li style="margin-left: 25px;">Fra et af dine favoritsteder</li>\
          <li style="margin-left: 25px;">Fra en af dine foretrukne adresser</li></ul>\
          <br><div class="tutorial-step-counter">'+this.step+'/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#position-selector',
            on: this.position
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('tag-tutorial', 'tag-custom-gps-next');
              }
            }
          ]
        });
        //Tag list
        this.step++;
        tour.addStep({
          id: 'tag-list',
          text: 'Klik på det enkelte sted for mere info.<br><div class="tutorial-step-counter">'+this.step+'/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '#tag-list',
            on: 'top'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Luk',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.complete();
                //console.log('tagTutorialComplete');
                localStorage.setItem('OdenseRundt-TutorialTag', 'false');
                if(this.tagId == 51 || this.tagId == 56) {
                  localStorage.setItem('OdenseRundt-TutorialFilter', 'false');
                }
                this.$HelperFunctions.trackSession('tag-tutorial', 'tag-tutorial-complete');
                //app.tagTutorialActive = false;
              }
            }
          ]
        });

        tour.start();
        /*app.tagTutorialActive = true;
        app.setScreenReaderFocus('tag-tutorial-anchor');*/
      });
    }
  };
</script>
